<template>
  <page-listado :fluid="false">
    <page-header title="Motivos de cierre de oferta">
      <b-button variant="primary" size="sm" to="/motivosCierreOferta/crear">
        <v-icon name="plus" width="16" />
        Crear motivo de cierre
      </b-button>
    </page-header>
    <tabla-motivos :motivos="motivos" @updated="listar" />
  </page-listado>
</template>
<script>
import { fetchData } from "@/services/backend.js";
import TablaMotivos from "./TablaMotivos.vue";
export default {
  components: { TablaMotivos },
  data() {
    return {
      motivos: [],
    };
  },
  methods: {
    async listar() {
      this.motivos = await fetchData("/motivosCierreOferta/listar");
    },
  },
  mounted() {
    this.listar();
  },
};
</script>
